import { render, staticRenderFns } from "./Popusti.vue?vue&type=template&id=2053a02a&"
import script from "./Popusti.vue?vue&type=script&lang=js&"
export * from "./Popusti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports